import preTestCommonActions from './preTestCommon.action';
import { CONTENT_IDS } from '../../../constants';

const { PreTestCommonConstants } = preTestCommonActions;

const initialState = {
  displayMode: 'default',
  showOverlay: false,
  contentId: CONTENT_IDS.default
};

function PreTestCommonReducer (state = initialState, action) {
  const { type = '', payload = null } = { ...action };

  switch (type) {
    case PreTestCommonConstants.SET_DISPLAY_MODE: {
      if (payload !== null) {
        return { ...state, displayMode: payload };
      }
      return state;
    }
    case PreTestCommonConstants.SHOW_OVERLAY: {
      if (payload !== null) {
        return { ...state, showOverlay: payload };
      }
      return state;
    }
    case PreTestCommonConstants.SET_CONTENT_ID: {
      if (payload !== null) {
        return { ...state, contentId: payload };
      }
      return state;
    }
    default: {
      return state;
    }
  }
}

export default PreTestCommonReducer;
